import { render, staticRenderFns } from "./NavItemSubCommunity.vue?vue&type=template&id=2988f7c8&scoped=true&"
import script from "./NavItemSubCommunity.vue?vue&type=script&lang=js&"
export * from "./NavItemSubCommunity.vue?vue&type=script&lang=js&"
import style0 from "./NavItemSubCommunity.vue?vue&type=style&index=0&id=2988f7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2988f7c8",
  null
  
)

export default component.exports